import { useEffect, useState } from "react"

// ** Third Party Components
import { NavLink, useLocation } from "react-router-dom"
import { ClipboardText, Folder, Home2, Notification, TaskSquare } from "iconsax-reactjs"

// ** Helpers
import { cn } from "@pma/utils/helpers"

// ** Routes
import { FILES_FOLDER_PAGE_ROUTE, MY_TASKS_PAGE_ROUTE, NEW_DASHBOARD_PAGE_ROUTE, PROJECT_PAGE_ROUTE } from "@pma/utils/page-routes"

// ** Custom Hooks
import useTranslator from "@pma/hooks/use-translator"

const BottomNav = () => {
  const { translate } = useTranslator()
  const location = useLocation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const onResize = () => setIsVisible(window.innerWidth < 1024) // show under lg
    onResize()
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  if (!isVisible) return null

  const navbarItem = [
    {
      title: "Home",
      Icon: Home2,
      path: NEW_DASHBOARD_PAGE_ROUTE,
    },
    {
      title: "Projects",
      Icon: ClipboardText,
      path: PROJECT_PAGE_ROUTE,
    },
    {
      title: "My Tasks",
      Icon: TaskSquare,
      path: MY_TASKS_PAGE_ROUTE,
    },
    {
      title: "Notifications",
      Icon: Notification,
      path: NEW_DASHBOARD_PAGE_ROUTE + "/notifications",
    },
    {
      title: "Files",
      Icon: Folder,
      path: FILES_FOLDER_PAGE_ROUTE,
    },
  ]

  return (
    <nav className='fixed inset-x-0 bottom-0 z-40 border-t border-neutral-200 bg-white/95 backdrop-blur xl:hidden'>
      <div className='mx-auto max-w-7xl'>
        <div className='grid grid-cols-5'>
          {navbarItem.map((navbar) => {
            const isActive = navbar.path
              ? location.pathname === navbar.path || location.pathname.startsWith(navbar.path + "/")
              : false

            return (
              <NavLink
                to={navbar.path}
                className={cn(
                  "flex flex-col items-center justify-center gap-1 px-3 py-2 text-xs font-medium text-neutral-500 hover:text-neutral-900",
                  isActive ? "!text-black" : "",
                )}
              >
                <navbar.Icon
                  size='20'
                  variant={isActive ? "Bold" : "Linear"}
                />
                <span className='font-[inter] text-[8px] font-normal'>{translate(navbar.title)}</span>
              </NavLink>
            )
          })}
        </div>
      </div>
    </nav>
  )
}

export default BottomNav
